// Brand Colors
export const colors = {
  primary: {
    main: '#C73866',    // Primary brand color
    light: '#FE676E',   // Secondary brand color
    dark: '#91284A',
    contrastText: '#FFFFFF'
  },
  secondary: {
    main: '#FD8F52',    // Tertiary brand color
    light: '#FFBD71',   // Fourth brand color
    dark: '#C66A3D',
    contrastText: '#FFFFFF'
  },
  accent: {
    light: '#FFDCA2',   // Fifth brand color
    main: '#FFBD71',
    dark: '#FD8F52'
  },
  background: {
    default: '#F8F9FA',
    paper: '#FFFFFF',
    dark: '#121212',
    subtle: '#F0F2F5',
    gradient: 'linear-gradient(135deg, #F8F9FA 0%, #FFFFFF 50%, #FEF6F8 100%)'
  },
  surface: {
    elevated: '#FFFFFF',
    overlay: 'rgba(255, 255, 255, 0.95)',
    card: '#FFFFFF'
  },
  text: {
    primary: '#1A1A2E',
    secondary: '#4A4A68',
    disabled: '#A0A0B0',
    hint: '#B0B0C0'
  },
  border: {
    light: '#E8EAED',
    medium: '#D0D2D5',
    dark: '#B8BABF'
  },
  shadow: {
    sm: '0 1px 3px rgba(0, 0, 0, 0.08)',
    md: '0 4px 12px rgba(0, 0, 0, 0.1)',
    lg: '0 8px 24px rgba(0, 0, 0, 0.12)',
    xl: '0 12px 48px rgba(0, 0, 0, 0.15)'
  },
  error: {
    main: '#FF3B30',
    light: '#FF6B66',
    dark: '#C70000'
  },
  warning: {
    main: '#FF9500',
    light: '#FFC107',
    dark: '#C66900'
  },
  success: {
    main: '#34C759',
    light: '#6EE895',
    dark: '#008A2C'
  },
  info: {
    main: '#007AFF',
    light: '#66AFFF',
    dark: '#004BA0'
  },
  grey: {
    50: '#FAFBFC',
    100: '#F4F5F7',
    200: '#EBECF0',
    300: '#DFE0E5',
    400: '#C1C2C8',
    500: '#A0A4AB',
    600: '#80838D',
    700: '#5E5F66',
    800: '#3C3D40',
    900: '#1A1A1A'
  },
  divider: 'rgba(0, 0, 0, 0.08)'
}; 